export interface SortableDayEntry {
  id?: string | number | null;
  date?: string;
  startTime?: number | null;
}

export interface SortedDayEntry<T extends SortableDayEntry> {
  entry: T;
  originalIndex: number;
}

export const sortDayEntries = <T extends SortableDayEntry>(
  entries: T[],
): SortedDayEntry<T>[] => {
  const groups = new Map<string, SortedDayEntry<T>[]>();
  entries.forEach((entry, originalIndex) => {
    const key = entry.date ? `date:${entry.date}` : `row:${originalIndex}`;
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key)!.push({ entry, originalIndex });
  });

  const minutes = (time?: number | null) => {
    if (time == null) {
      return Infinity;
    }
    const date = new Date(time);
    return Number.isNaN(date.getTime())
      ? Infinity
      : date.getHours() * 60 + date.getMinutes();
  };

  return Array.from(groups.values()).flatMap(([first, ...parts]) => {
    parts.sort((a, b) => {
      const aTime = minutes(a.entry.startTime);
      const bTime = minutes(b.entry.startTime);
      if (aTime === bTime) {
        return a.originalIndex - b.originalIndex;
      }
      return aTime < bTime ? -1 : 1;
    });
    // The first row carries the day's controls, including on an unreported day.
    return [first, ...parts];
  });
};
